function getGoogleAdUnitApiFactory(storefrontApiClient) {
  const getGoogleAdUnitApi = {
    getGoogleAdUnit(params) {
      return storefrontApiClient.get('adUnit', {params}, {});
    },
  };
  return getGoogleAdUnitApi;
}

export default getGoogleAdUnitApiFactory;
